/**********************************************************
Mowing Create
**********************************************************/
import CultivationModal from '../cult_modal';
import MowingForm from './mowing_form';
import MowingApplicationDisplay from './mowing_app_display';
import MowingAppList from './mowing_list';
import { fetchFields, clearForm } from '../../actions/utils_actions';
import { addMow, editMow, selectMowToEdit, deleteMow, prepareMow,
 createOrEditMowingApplication, selectMowAppToEdit } from '../../actions/mowing_actions';
import { packageForm, filterOldRecords } from '../../cult_utils';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class MowingCreate extends Component {
  render() {
    return (
      <div>
      <div className="row">
      { Object.keys(this.props.user).length === 0 ? ''
        : this.props.user.level >= 3 || this.props.user.positionTitle.match(/Cultivation/) ?
        <div>
          <div className="col s12 m3 l3 xl3">
            <div className="chem-container">
              <MowingAppList mowingRecords={this.props.mowingRecords.filter(filterOldRecords)} employees={this.props.employees}
                onClick={this.props.selectMowAppToEdit} />
            </div>
          </div>
          <div className="col s12 m9 l9 xl9">
            <MowingForm formId={'mowing-form'} employees={this.props.employees} fields={this.props.fields} mowJobs={this.props.mowJobs}
              isEditing={this.props.isEditing} mowAppId={this.props.mowAppId} editingMow={this.props.editingMow} selectMowToEdit={this.props.selectMowToEdit}
              fetchFields={this.props.fetchFields} addMow={this.props.addMow} editMow={this.props.editMow} deleteMow={this.props.deleteMow}
            />
            <div className="row">
              <div className="col s12">
                <div className="card-footer">
                  <a className="waves-effect waves-light btn modal-trigger" href={'#mowing-app-prepare'}
                    onClick={() => this.props.prepareMow({
                      user: this.props.user,
                      form: packageForm('mowing-form'),
                      fields: this.props.fields,
                      employees: this.props.employees,
                      mowJobs: this.props.mowJobs,
                      mowAppId: this.props.mowAppId,
                      editingApplication: this.props.editingApplication
                    })}>
                    Prepare
                  </a>
                  <button className="btn btn-flat"
                    onClick={() => { this.props.clearForm('mowing-form'); this.props.clearForm('mow-used-form') }}>Clear</button>
                </div>
              </div>
              {
                CultivationModal(MowingApplicationDisplay)
                // eslint-disable-next-line
                ({
                  id: 'mowing-app-prepare',
                  employees: this.props.employees,
                  footer: true,
                  createOrEdit: true,
                  onClick: () => this.props.createOrEditMowingApplication({
                    data: { ...this.props.application, deletedMowingRecords: this.props.deletedMowingRecords },
                    path: this.props.path,
                    type: this.props.type
                  }),
                  application: this.props.application,
                  previousApplications: this.props.previousApplications
                })
              }
            </div>
          </div>
        </div>
        : <h5>Unauthorized</h5>
      }
      </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    application: state.cultivation.mowing.app.application,
    deletedMowingRecords: state.cultivation.mowing.app.deletedMowingRecords,
    editingApplication: state.cultivation.mowing.app.editingApplication,
    editingMow: state.cultivation.mowing.app.editingMow,
    employees: state.cultivation.utils.employees,
    fields: state.cultivation.utils.fields,
    isEditing: state.cultivation.mowing.app.isEditing,
    mowAppId: state.cultivation.mowing.app.mowAppId,
    mowJobs: state.cultivation.mowing.app.mowJobs,
    mowingRecords: state.cultivation.mowing.mowingRecords.displaying,
    path: state.cultivation.mowing.app.path,
    previousApplications: state.cultivation.mowing.app.previousApplications,
    type: state.cultivation.mowing.app.type,
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addMow,
    clearForm,
    createOrEditMowingApplication,
    deleteMow,
    editMow,
    fetchFields,
    prepareMow,
    selectMowToEdit,
    selectMowAppToEdit
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(MowingCreate);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/mowing/mowing_create.js